export const EVENTS = {
  AUTHENTICATION: {
    LOGGED_IN: 'Logged In'
  },
  WORK_LIST: {
    CLICK: {
      STUDY: 'Click on Study from Work List'
    },
    FORM_SUBMISSION: {
      REJECT_STUDY: 'Reject Study from Work List',
      REASON_FOR_REJECTION: 'Reason for Rejection'
    }
  },
  STUDY_LIST: {
    CLICK: {
      STUDY: 'Click on Study from Study List',
      ADD_STUDY_BUTTON: 'Click Add Study',
      DOWNLOAD_DICOM_FILES: 'Click Download DICOM Files from Study List',
      PRINT_PDF_WITH_DATA_ONLY: 'Print with data only from Study List',
      PRINT_PDF_WITH_FOOTER_ONLY: 'Print with footer only from Study List',
      PRINT_PDF_WITH_HEADER_ONLY: 'Print with header only from Study List',
      PRINT_PDF_NORMAL: 'Print normal from Study List'
    }
  },
  UPLOAD_STUDIES: {
    CLICK: {
      UPLOAD_BUTTON: 'Click Upload Selected',
      BACK_BUTTON: 'Click Back button from Upload'
    }
  },
  STUDY_TABS: {
    DETAIL_TAB: 'Click Study Detail Tab',
    KNOWLEDGE_BASE_TAB: 'Click Knowledge Base Tab',
    QUESTIONNAIRE_TAB: ' Click Questionnaire Tab',
    RELATED_DOCUMENTS_TAB: 'Click Related Documents Tab',
    REPORT_TAB: 'Click Study Report Tab',
    TIMELINE_TAB: 'Click Timeline Tab'
  },
  STUDY_DETAIL: {
    CLICK: {
      ASSIGN_BUTTON: 'Click Assign Button',
      BACK_BUTTON: 'Click Back Button from Study Detail',
      DOWNLOAD_DICOM_FILES: 'Click Download DICOM Files from Study Detail',
      PRINT_PDF_WITH_DATA_ONLY: 'Print with data only from Study List',
      PRINT_PDF_WITH_FOOTER_ONLY: 'Print with footer only from Study List',
      PRINT_PDF_WITH_HEADER_ONLY: 'Print with header only from Study List',
      PRINT_PDF_NORMAL: 'Print normal from Study List',
      SAVE_DETAIL_BUTTON: 'Click Study Detail Save Button',
      VIEWER_BUTTON: 'Click Viewer'
    },
    FORM_SUBMISSION: {
      PHONE_NUMBER: 'Add Phone Number',
      PATIENT_NAME: 'Edit Patient Name',
      PATIENT_ID: 'Edit Patient ID',
      AGE_OR_DOB_SELECTOR: 'Click Age/DOB clicker',
      AGE: 'Edit Age',
      DOB: 'Edit DoB',
      URGENCY: 'Edit Urgency',
      BODY_PART_EXAMINED: 'Add Body Part Examined',
      PROCEDURE: 'Add Procedure',
      STUDY_DESCRIPTION: 'Edit Study Description',
      SELECT_REFERRING_PHYSICIAN: 'Select Referring Physician from List',
      ADD_NEW_REFERRING_PHYSICIAN: 'Add new Referring Physician',
      ADD_MEDICAL_HISTORY: 'Add Medical History',
      SELECT_QUESTIONNAIRE: 'Select Questionnaire',
      ASSIGN_STUDY_TO_SELF: 'Assign Study to Self',
      ASSIGN_STUDY_TO_OWN_FACILITY: 'Assign Study to My Facility',
      ASSIGN_STUDY_TO_FACILITY: 'Assign Study to Facility',
      ASSIGN_STUDY_TO_RADIOLOGY_PROVIDER: 'Assign Study to Radiology Providers',
      ASSIGN_STUDY_TO_STUFF_RADIOLOGIST: 'Assign Study to Stuff Radiologists',
      ASSIGN_STUDY_TO_INDEPENDENT_RADIOLOGIST: 'Assign Study to Independent Radiologist'
    }
  },
  STUDY_REPORT: {
    FORM_SUBMISSION: {
      PROCEDURE: 'Procedure Added',
      TEMPLATE_SELECTED: 'Report Template Selected',
      ACTIONABLE_FINDINGS: 'Actionable Findings Selected',
      TECHNIQUE: 'Technique Added',
      CLINICAL_INFORMATION: 'Clinical Information Added',
      COMPARISON: 'Comparison Added',
      FINDINGS: 'Findings Added',
      IMPRESSION: 'Impression Added'
    },
    CLICK: {
      REPORT_SAVE: 'Click Save Report',
      REPORT_SIGNED: 'Click Sign Report',
      REPORT_REVISED: 'Click Revise Report',
      BACK_BUTTON: 'Click Back Button from Report'
    }
  },
  SIDE_BAR: {
    CLICK: {
      MY_UPLOADS: 'Click My Uploads',
      WORK_LIST: 'Click Work List',
      STUDY_LIST: 'Click Study List',
      STUDY_SHARE_LIST: 'Click Study Share List',
      UPLOAD_APP_BUTTON: 'Click AlemHealth Uploader',
      SIGN_OUT: 'Click Sign Out',
      SUPPORT: 'Click Support'
    }
  }
}
